import classNames from 'classnames';
import type { MenuProps as RcMenuProps, MenuRef as RcMenuRef } from 'rc-menu';
import RCMenu from 'rc-menu';
import React from 'react';
import { MenuContextProvider } from './menu.context';
import initCollapseMotion from './menu.motion';
import { MenuStyles } from './menu.styled';
import useItems, { ItemType } from './menu.utils';

export interface MenuProps extends Omit<RcMenuProps, 'children' | 'multiple' | 'selectable'> {
  items?: ItemType[];
  selectMode?: 'single' | 'multi';
}

const rootPrefixCls = 'ui-menu';

/**
 * Menu component.
 * Inspired by https://ant.design/components/menu api
 */
const Menu = (props: MenuProps, ref?: React.Ref<RcMenuRef>) => {
  const { items, className, selectedKeys, selectMode, ...rest } = props;

  const mergedChildren = useItems(items);
  const defaultMotions = {
    horizontal: { motionName: `${rootPrefixCls}-slide-up` },
    inline: initCollapseMotion(rootPrefixCls),
    other: { motionName: `${rootPrefixCls}-zoom-big` },
  };

  return (
    <>
      <MenuStyles />
      <MenuContextProvider value={{ selectMode, selectedKeys }}>
        <RCMenu
          {...rest}
          defaultMotions={defaultMotions}
          ref={ref}
          className={classNames('ui-menu', classNames)}
          selectable={selectMode !== undefined}
          multiple={selectMode === 'multi'}
          selectedKeys={selectedKeys}
        >
          {mergedChildren}
        </RCMenu>
      </MenuContextProvider>
    </>
  );
};

export default React.forwardRef(Menu);
